var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11803",
    "data-name": "Group 11803",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "auto",
    height: "auto",
    viewBox: "0 0 35.333 31.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1968",
    "data-name": "Rectangle 1968",
    width: 35.333,
    height: 31.943,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11802",
    "data-name": "Group 11802",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8095",
    "data-name": "Path 8095",
    d: "M14.588,29.1.306,53.835a2.256,2.256,0,0,0,1.953,3.384H30.824a2.256,2.256,0,0,0,1.954-3.384L18.5,29.1a2.256,2.256,0,0,0-3.907,0",
    transform: "translate(0 -25.275)",
    fill: "#ff005f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8096",
    "data-name": "Path 8096",
    d: "M32.255,31.465H3.69A3.364,3.364,0,0,1,.777,26.42L15.059,1.682h0a3.364,3.364,0,0,1,5.826,0L35.167,26.42a3.363,3.363,0,0,1-2.913,5.045M16.978,2.789,2.7,27.527a1.148,1.148,0,0,0,.994,1.722H32.255a1.148,1.148,0,0,0,.994-1.722L18.966,2.789a1.148,1.148,0,0,0-1.988,0",
    transform: "translate(-0.29)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8097",
    "data-name": "Path 8097",
    d: "M168.458,105.678c-2.531-.19-1.808,10.432,0,10.559s2.531-10.369,0-10.559",
    transform: "translate(-150.751 -95.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8098",
    "data-name": "Path 8098",
    d: "M167.866,233.152a1.874,1.874,0,1,1-1.874-1.874,1.874,1.874,0,0,1,1.874,1.874",
    transform: "translate(-148.311 -209.001)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a1d9321a7f1f8f8fc08f9854959db80b.svg";
export { ForwardRef as ReactComponent };